import {
  submitCancelPolicy,
  type CancelPolicySubmitRequest,
  type CancelPolicySubmitResponse,
} from "@tm/insurance/api";
import { useCallback, useState } from "react";

interface UseSubmitCancelPolicyResult {
  submit: (
    req: CancelPolicySubmitRequest
  ) => Promise<CancelPolicySubmitResponse>;
  isLoading: boolean;
  error: Error | null;
}

export function useSubmitCancelPolicy(): UseSubmitCancelPolicyResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const submit = useCallback(
    async (
      req: CancelPolicySubmitRequest
    ): Promise<CancelPolicySubmitResponse> => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await submitCancelPolicy(req);
        return response;
      } catch (err) {
        const normalised = err instanceof Error ? err : new Error(String(err));
        setError(normalised);
        throw normalised;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { submit, isLoading, error };
}
